<rs-top-bar-menu
  application="MRT"
  (onLogout)="clearCurrentUserOnLogout()"
  (onRouteChange)="topBarRouteChange($event)"
  [menuItems]="menuItems()"
  sortSubMenuItemsBy="ASC"
/>

<rs-loader />

<router-outlet [attr.data-app-version]="appVersion" />

<rs-footer />